<template>
    <div>
        <v-layout row wrap :align-center="!wideLayout" :justify-center="!wideLayout" :fill-height="!wideLayout">
            <v-flex xs12 sm12 :md12="wideLayout" :lg12="wideLayout" :md8="!wideLayout" :lg8="!wideLayout">
                

                <v-data-table
                v-model="selectedItem"
                :single-select="singleSelect"
                :headers="headers"
                :items="items"
                :options.sync="options"
                :server-items-length="totalItems"
                :loading="loading"
                class="elevation-1"
                :footer-props="{
                showFirstLastPage: true,
                firstIcon: 'mdi-page-first',
                lastIcon: 'mdi-page-last',
                prevIcon: 'mdi-chevron-left',
                nextIcon: 'mdi-chevron-right',
                itemsPerPageOptions: [5,10,15,25,50, 100]
                }"
                show-select
                >
                <template v-slot:top>
                    <v-switch v-model="singleSelect" label="Single select" class="pa-3"></v-switch>
                </template>
                <template v-slot:top>
                    <v-toolbar class="elevation-0" color="white">
                        <v-toolbar-title class="font-weight-regular body-1">{{ settings.title}}</v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-flex xs4 md4 lg4 v-show="breakPoint">
                            <!--<v-text-field class="pt-4"  label="Išči..." @keyup.esc="search = ''" v-model="search" append-icon="mdi-magnify" single-line></v-text-field>-->
                            <v-text-field class="pt-4"  label="Išči..." @keyup.esc="search = ''"  @keyup="doSearch()" v-model="search" append-icon="mdi-magnify" single-line clearable @click:clear="doSearch()"></v-text-field>
                        </v-flex>
                        <v-divider
                        class="mx-4"
                        inset
                        vertical
                        ></v-divider>
                        <v-tooltip v-if="btnRefresh" top>
                            <template v-slot:activator="{ on }">
                                <v-btn @click="refreshDataTable" class="toolbar_btn_fab" elevation="0" color="secondary" v-on="on" fab x-small dark>
                                    <v-icon>mdi-sync</v-icon>
                                </v-btn>
                            </template>
                            <span>Osveži podatke</span>
                        </v-tooltip>
                        <v-tooltip v-if="selectedItem.length > 0" top>
                            <template v-slot:activator="{ on }">
                                <v-btn @click="selectedItem = []" class="toolbar_btn_fab" elevation="0" color="error" v-on="on" fab x-small dark>
                                    <v-icon>mdi-close</v-icon>
                                </v-btn>
                            </template>
                            <span>Odznači izbranega uporabnika</span>
                        </v-tooltip>
                        <v-tooltip v-if="btnAddNew" top>
                            <template v-slot:activator="{ on }">
                                <v-btn @click="addNewItem()" class="toolbar_btn_fab" elevation="0" color="secondary" v-on="on" fab x-small dark>
                                    <v-icon>mdi-plus</v-icon>
                                </v-btn>
                            </template>
                            <span>Dodaj nov zapis</span>
                        </v-tooltip>
                    </v-toolbar>
                    <v-divider></v-divider>
                </template>
                <template v-slot:item.action="{ item }">
                    <!--<v-tooltip top>
                        <template v-slot:activator="{ on }">
                            <v-icon
                                color="success"
                                small
                                class="mr-2 dt_btn_edit"
                                @click="editItem(item)"
                                v-on="on"
                            >
                                mdi-pencil
                            </v-icon>
                        </template>
                        <span>Uredi</span>
                    </v-tooltip>-->
                    <v-tooltip top>
                        <template v-slot:activator="{ on }">
                            <v-icon
                                color="indigo"
                                small
                                class="mr-2 dt_btn_view"
                                @click="viewItem(item)"
                                v-on="on"
                            >
                                mdi-magnify-plus-outline
                            </v-icon>
                        </template>
                        <span>Prikaži</span>
                    </v-tooltip>
                    <!--<v-tooltip top>
                        <template v-slot:activator="{ on }">
                            <v-icon
                                id="dt_btn_delete"
                                color="error"
                                small
                                @click="deleteItem(item)"
                                v-on="on"
                            >
                                mdi-delete
                            </v-icon>
                        </template>
                        <span>Izbriši</span>
                    </v-tooltip>-->
                </template>
                <template v-slot:item.applications_status_waiting="{ item }">
                    <v-chip v-if="item.applications_status_waiting !== null && item.applications_status_waiting !=='null' && item.applications_status_waiting !== ''" :color="getApplicationStatusWaitingColor(item.application_status_waiting)" dark small>{{ item.applications_status_waiting }}</v-chip>
                    <span v-else>{{ item.applications_status.waiting }}</span>
                </template>
                <template v-slot:item.permits_status_active="{ item }">
                    <v-chip v-if="item.permits_status_active !== null && item.permits_status_active !=='null' && item.permits_status_active !== ''" :color="getPermitStatusActiveColor(item.permits_status_active)" dark small>{{ item.permits_status_active }}</v-chip>
                    <span v-else>{{ item.permits_status_active}} </span>
                </template>
                <template v-slot:progress>
                    <v-progress-linear absolute  indeterminate :height="progressHeight()"></v-progress-linear>
                </template>
                <template slot="no-data">
                    <div class="no_data" v-show="!searchQuery">{{ (this.loading) ? "Obdelava podatkov je v teku ..." : "Ni podatkov za prikaz." }}</div>
                    <div class="no_data" v-show="searchQuery">{{ (this.loading) ? 'Obdelava podatkov za iskani niz "'  + this.search + '" je v teku ...' :  `Ni podatkov za iskani niz »${this.search}«.`}}</div>
                </template>
                <template slot="loading">
                    <div class="no_data">Obdelava podatkov je v teku ...</div>
                </template>
                </v-data-table>
            </v-flex>

            <v-dialog v-model="dialog" persistent max-width="490">
                <v-card>
                    <v-card-title></v-card-title>
                    <v-card-text>
                        <v-icon text>mdi-delete</v-icon>
                        {{ dialog_text }}
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn text color="error" @click.native="dialogCancel()">Prekliči</v-btn>
                        <v-btn text :loading="loading" color="success" @click.native="dialogConfirm()">Nadaljuj</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>

            <!-- details dialog -->
            <!-- dialog -->
        <v-dialog v-model="detailsDialog" max-width="650px">
        <v-card>
          <v-card-title class="dialog_card_title">
            <span class="subtitle-1 font-weight-medium"><v-icon left>mdi-account</v-icon>Podatki o imetniku </span>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text>
            <v-container grid-list-md>

                <v-layout row wrap>
                    <v-flex xs12 sm12 md6 lg6>
                        <span>Naziv:</span>
                    </v-flex>
                    <v-flex xs12 sm12 md6 lg6>
                        <span class="font-weight-medium">{{ dialogItemObject.name }}</span>
                    </v-flex>
                </v-layout>
                <v-layout row wrap>
                    <v-flex xs12 sm12 md6 lg6>
                        <span>Naslov (prebivališče):</span>
                    </v-flex>
                    <v-flex xs12 sm12 md6 lg6>
                        <span class="font-weight-medium">{{ dialogItemObject.address }}</span>
                    </v-flex>
                </v-layout>
                <v-layout row wrap>
                    <v-flex xs12 sm12 md6 lg6>
                        <span>Kraj:</span>
                    </v-flex>
                    <v-flex xs12 sm12 md6 lg6>
                        <span class="font-weight-medium">{{ dialogItemObject.town }}</span>
                    </v-flex>
                </v-layout>
                <v-layout row wrap>
                    <v-flex xs12 sm12 md6 lg6>
                        <span>Poštna številka:</span>
                    </v-flex>
                    <v-flex xs12 sm12 md6 lg6>
                        <span class="font-weight-medium">{{ dialogItemObject.postal_code }}</span>
                    </v-flex>
                </v-layout>
                <v-layout row wrap>
                    <v-flex xs12 sm12 md6 lg6>
                        <span>Tip prebivališča:</span>
                    </v-flex>
                    <v-flex xs12 sm12 md6 lg6>
                        <span class="font-weight-medium">{{ dialogItemObject.residence_type }}</span>
                    </v-flex>
                </v-layout>
                <v-layout row wrap>
                    <v-flex xs12 sm12 md6 lg6>
                        <span>Telefonska številka:</span>
                    </v-flex>
                    <v-flex xs12 sm12 md6 lg6>
                        <span class="font-weight-medium">{{ dialogItemObject.phone_number }}</span>
                    </v-flex>
                </v-layout>
                <v-layout row wrap>
                    <v-flex xs12 sm12 md6 lg6>
                        <span>Emšo:</span>
                    </v-flex>
                    <v-flex xs12 sm12 md6 lg6>
                        <span class="font-weight-medium">{{ dialogItemObject.emso }}</span>
                    </v-flex>
                </v-layout>
                <v-layout row wrap v-if="dialogItemObject.entity_type.name != ''">
                    <v-flex xs12 sm12 md6 lg6>
                        <span>Tip osebe:</span>
                    </v-flex>
                    <v-flex xs12 sm12 md6 lg6>
                        <span class="font-weight-medium">{{ dialogItemObject.entity_type }}</span>
                    </v-flex>
                </v-layout>
                <v-layout row wrap v-if="dialogItemObject.tax_number != '' && dialogItemObject.tax_number != null">
                    <v-flex xs12 sm12 md6 lg6>
                        <span>Davčna številka:</span>
                    </v-flex>
                    <v-flex xs12 sm12 md6 lg6>
                        <span class="font-weight-medium">{{ dialogItemObject.tax_number }}</span>
                    </v-flex>
                </v-layout>
            </v-container>
          </v-card-text>
        <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn @click="closeDialogWindow()" color="error" text>Zapri</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
        </v-layout>
    </div>
</template>

<script>
import { post, get, put, destroy, API_ENDPOINT, DEMO_API_ENDPOINT } from '@/helpers/api'
import { EventBus } from '@/main.js'

export default {
    props: ['settings', 'queryParameters', 'boxedLayout'],
    name: 'select-permit-holder-data-table',

    data: () => ({
        detailsDialog: false,
        search: '',
        totalItems: 0,
        items: [],
        loading: true,
        options: {},
        rowsPerPageItems: [5,10,15,25,50,100, -1], 
        interval: null,
        dialog: false,
        dialog_text: '',
        itemToDelete: null,
        selectedItem: [],
        singleSelect: true,
        itemToDisplay: null,
        searchTimer: null
    }),

    watch: {
        options: {
            handler () {
            this.getDataFromApi()
                .then(data => {
                   this.items = data.items
                   this.totalItems = data.totalItems
               })
               .catch(error => {
                   this.items = [];
                   this.totalItems = 0;
                   window.console.log(error)
               })

                //window.console.log(this.options)
                //window.console.log(this.params)
            },
            deep: true,
        },

        /*search(newValue) {
            this.getDataFromApi()
                .then(data => {
                   this.items = data.items
                   this.totalItems = data.totalItems
               })
               .catch(error => {
                   this.items = [];
                   this.totalItems = 0;
                   window.console.log(error)
               })
        },*/

        selectedItem(newValue) {
            //window.console.log(newValue[0]);
            EventBus.$emit(this.settings.eventBus.selectedItem, newValue)
        },

        searchFromStore(newValue) {
            this.search = newValue
            this.doSearch()
        }
    },

    computed: {
        params(nv) {
            return {
                ...this.options,
                query: this.search
            }
        },

        searchQuery() {
           return (this.search != null && this.search.trim() != '') ? true : false;
       },

       btnRefresh() {
           if(this.settings && this.settings.toolbar && this.settings.toolbar.buttons && this.settings.toolbar.buttons.refresh) {
               return true
           }

           return false
       },

       btnExport() {
           if(this.settings && this.settings.toolbar && this.settings.toolbar.buttons && this.settings.toolbar.buttons.export) {
               return true
           }

           return false
       },

       btnAddNew() {
           if(this.settings && this.settings.toolbar && this.settings.toolbar.buttons && this.settings.toolbar.buttons.addNew) {
               return true
           }

           return false
       },

       btnToggleColumns() {
           if(this.settings && this.settings.toolbar && this.settings.toolbar.buttons && this.settings.toolbar.buttons.toggleColumns && 
                this.settings.eventBus && this.settings.eventBus.toggleColumnsId != null && this.settings.eventBus.toggleColumnsId.trim() != ''
           ) {
               return true
           }

           return false
       },

       breakPoint() {
           if(this.$vuetify.breakpoint.mdAndUp) {
                return true;
            }

             return false;
       },

       apiParams() {
           let params = {
                ...this.options,
                query: this.search,
                columns: this.settings.headers.map(header => {
                    return header.value
                })
            }

            if(this.queryParameters && this.queryParameters != null) {
                let queryParams = this.queryParameters
                params = {
                    ...params,
                    ...queryParams
                }
            }

            //window.console.log("queryParams")
            //window.console.log(params)

           return params;
       },

       headers() {
           return this.settings.headers.filter(header => {
               if(header.visibility) {
                   return header
               }
           });
       },

       searchFromStore: {
           get() {
               return this.$store.getters.search
           },

           set(value) {
               this.$store.commit('SET_SEARCH', this.search)
           }
       },

       wideLayout() {
           if(this.boxedLayout !== undefined) {
               if(this.boxedLayout === true) {
                   return false
               }

               return true
           }

           return true
       },

       dialogItemObject() {
           let data = {
               id: "",
               name: "",
               address: "",
               town: "",
               postal_code: "",
               residence_type: "",
               phone_number: "",
               emso: "",
               entity_type: "",
               tax_number: "",
               user: ""
               
           }

           if(this.itemToDisplay == null || this.itemToDisplay == undefined) {
               return data;
           }

            data.id = this.itemToDisplay.id;
            data.name = this.itemToDisplay.name;
            data.address = this.itemToDisplay.address
            data.town = this.itemToDisplay.town
            data.postal_code = this.itemToDisplay.postal_code
            data.residence_type = (this.itemToDisplay.residence_type !== null) ? this.itemToDisplay.residence_type.name : "N/A",
            data.phone_number = this.itemToDisplay.phone_number
            data.emso = this.itemToDisplay.emso
            data.entity_type = (this.itemToDisplay.entity_type !== null) ? this.itemToDisplay.entity_type.name : "N/A"
            data.tax_number = this.itemToDisplay.tax_number
            data.user = (this.itemToDisplay.user) ?  this.itemToDisplay.user.name : "N/A"


           return data;
       },
    },

    methods: {
        getDataFromApi () {
            this.loading = true
            
            if(this.settings.hasOwnProperty('eventBus') && this.settings.eventBus.hasOwnProperty('totalItems')) {
                if(this.settings.eventBus.totalItems) {
                    EventBus.$emit(this.settings.eventBus.totalItems.event, {progress: true, value: 0})
                }
            }

            if(this.settings.hasOwnProperty('eventBus') && this.settings.eventBus.hasOwnProperty('sumItems')) {
                if(this.settings.eventBus.sumItems) {
                    EventBus.$emit(this.settings.eventBus.sumItems.event, {progress: true, queryParameters: this.apiParams})
                }
            }

            return new Promise((resolve, reject) => {
                //post(API_ENDPOINT + this.settings.endpoint, this.apiParams)
                post(API_ENDPOINT + this.settings.endpoint, this.apiParams)            
                .then(response => {
                    //window.console.log("API data")
                    //window.console.log(response)
                    const {
                       sortBy,
                       sortDesc, 
                       page,
                       itemsPerPage 
                    } = this.options;

                    //this.pagination.rowsPerPage = response.data.meta.per_page
                    //console.log(response)
                    const items = response.data.data
                    const totalItems = response.data.meta.total

                    if(this.settings.hasOwnProperty('eventBus') && this.settings.eventBus.hasOwnProperty('totalItems')) {
                        if(this.settings.eventBus.totalItems) {
                            EventBus.$emit(this.settings.eventBus.totalItems.event, {value: totalItems})
                        }
                    }

                    resolve({items, totalItems})
                })
                .catch(error => {
                    if(this.settings.hasOwnProperty('eventBus') && this.settings.eventBus.hasOwnProperty('totalItems')) {
                        if(this.settings.eventBus.totalItems) {
                            EventBus.$emit(this.settings.eventBus.totalItems.event, {value: 0})
                        }
                    }
                    reject(error)
                })
                .finally(() => {
                    this.loading = false
                    if(this.settings.hasOwnProperty('eventBus') && this.settings.eventBus.hasOwnProperty('totalItems')) {
                        if(this.settings.eventBus.totalItems) {
                            EventBus.$emit(this.settings.eventBus.totalItems.event, {progress: false})
                        }
                    }
                })
            })
      },

      editItem(item) {
           //console.log(item)
           if(this.settings && this.settings.editItem && this.settings.editItem.route) {
               //window.console.log(item)
               //window.console.log(this.settings.editItem.route)
               //window.console.log(item[this.settings.editItem.routeParameterValue])

               this.$router.push({
                   name: this.settings.editItem.route,
                   params: {
                       id: item[this.settings.editItem.routeParameterValue]
                   }
               })
           }

           if(this.settings && this.settings.editItem && this.settings.editItem.hasOwnProperty('dialog')) {
               if(this.settings.editItem.dialog == true && this.settings.eventBus.editDialog != '') {
                   EventBus.$emit(this.settings.eventBus.editDialog, {item: item})
               }
           }

       },

       deleteItem(item) {
           this.itemToDelete = item
           //console.log(item)
            if(this.settings.hasOwnProperty('deleteItem') && this.settings.deleteItem != null) {
                this.dialog_text = this.settings.deleteItem.confirmationText.replace('{str_to_replace}', this.itemToDelete[this.settings.deleteItem.replaceStrWithColumnValue])
            }
            else {
                this.dialog_text = 'Ste prepričani da želite odstraniti zapis' + this.itemToDelete.id + '?'
            }
           this.dialog = true

           //console.log(this.itemToDelete)
       },

       dialogConfirm() {
           new Promise( (resolve, reject) => {
               this.loading = true
               if(this.settings.deleteItem.vuexAction != '' && this.settings.deleteItem.vuexAction != null) {
                   //this.$store.dispatch(this.settings.deleteItem.vuexAction, this.itemToDelete.id)
                   this.$store.dispatch(this.settings.deleteItem.vuexAction, this.itemToDelete[this.settings.editItem.routeParameterValue])
                    .then(response => {
                        this.dialog = false
                        this.loading = false    
                        this.$store.state.snackbar.mode = ''
                        this.$store.state.snackbar.display = true
                        this.$store.state.snackbar.text = this.settings.deleteItem.dialogConfirmSuccessText.replace('{str_to_replace}', this.itemToDelete[this.settings.deleteItem.replaceStrWithColumnValue])

                        this.itemToDelete = null
                        this.refreshDataTable()

                    })
                    .catch(error => {
                        //window.console.log(error)
                        this.dialog = false
                        this.loading = false    
                        this.$store.state.snackbar.mode = 'multi-line'
                        this.$store.state.snackbar.display = true
                        this.$store.state.snackbar.text = this.settings.deleteItem.dialogConfirmFailText.replace('{str_to_replace}', this.itemToDelete[this.settings.deleteItem.replaceStrWithColumnValue])
                        this.itemToDelete = null
                    })
               } else {
                    this.dialog = false
                    this.loading = false    
                    this.$store.state.snackbar.mode = 'multi-line'
                    this.$store.state.snackbar.display = true
                    this.$store.state.snackbar.text = this.settings.deleteItem.dialogConfirmFailText.replace('{str_to_replace}', this.itemToDelete[this.settings.deleteItem.replaceStrWithColumnValue])
                    this.itemToDelete = null
               }
           })
        },

       dialogCancel() {
            this.dialog_confirm = false
            this.dialog = false
            this.itemToDelete = null
       },

       addNewItem() {
           if(this.settings.toolbar.buttons.addNewRoute != '' && this.settings.toolbar.buttons.addNewRoute != null) {
               this.$router.push({name: this.settings.toolbar.buttons.addNewRoute})
           }
       },

       refreshDataTable() {
           this.getDataFromApi()
                .then(data => {
                   this.items = data.items
                   this.totalItems = data.totalItems
               })
               .catch(error => {
                   this.items = [];
                   this.totalItems = 0;
                   window.console.log(error)
               })
       },

       progressHeight() {
           if(this.settings.hasOwnProperty('progressHeight') && this.settings.progressHeight != null && this.settings.progressHeight != '') {
               return this.settings.progressHeight
           }

           return 3
       },

       getApplicationStatusWaitingColor(application_status) {
           //window.console.log("getApplicationStatusColor");
           //window.console.log(application_status)
           return 'warning';
       },

       getPermitStatusActiveColor(permit_type) {
           return 'green'
       },

       viewItem(item) {
           window.console.log(item)
           this.itemToDisplay = item
           this.detailsDialog = true
       },

       closeDialogWindow() {
           this.detailsDialog = false
       },

       doSearch() {
           let vm = this
           if(this.searchTimer) {
               clearTimeout(this.searchTimer)
               this.searchTimer = null
           }

           this.searchTimer = setTimeout(() => {
               vm.getDataFromApi()
                .then(data => {
                   vm.items = data.items
                   vm.totalItems = data.totalItems
               })
               .catch(error => {
                   vm.items = [];
                   vm.totalItems = 0;
                   window.console.log(error)
               })
           }, 600)
       }
    },

    created() {
        //window.console.log("DataTableSettings");
        //window.console.log(this.settings)

        //window.console.log("Query Parameters")
        //window.console.log(this.queryParameters)
    },

    mounted() {
        if(this.settings && this.settings.sortColumn) {
            this.options.sortBy = this.settings.sortColumn
        }

        if(this.settings && this.settings.sortDirection && this.settings.sortDirection == 'desc') {
            this.options.sortDesc = this.settings.sortDirection
        }

        if(this.settings && this.settings.hasOwnProperty('eventBus')) {
            if(this.settings.eventBus.refreshDataTable != null && this.settings.eventBus.refreshDataTable.trim() != '' ) {
                EventBus.$on(this.settings.eventBus.refreshDataTable, (data) => {
                    this.refreshDataTable()
                })
            }

            if(this.settings.eventBus.search != null && this.settings.eventBus.search.trim() != '') {
                EventBus.$on(this.settings.eventBus.search, (data) => {
                    this.search = data
                })
            }

            if(this.settings.eventBus.removeSelectedItem != null && this.settings.eventBus.removeSelectedItem != '') {
                EventBus.$on(this.settings.eventBus.removeSelectedItem, (data) => {
                    this.selectedItem = []
                })
            } 
        }

        if(this.settings && this.settings.updateInterval) {
            this.interval = setInterval(() => {
                if(this.loading != true) {
                    this.getDataFromApi()
                    .then(data => {
                        this.items = data.items
                        this.totalItems = data.totalItems
                    })
                    .catch(error => {
                        this.items = [];
                        this.totalItems = 0;
                        window.console.log(error)
                    })
                }
            }, 30000)
       }

       if(this.settings && this.settings.rowsPerPage) {
           this.options.itemsPerPage = this.settings.rowsPerPage
       }
    },

    beforeDestroy() {

    },

    destroyed() {
        clearInterval(this.interval)
        if(this.settings && this.settings.eventBus  && this.settings.eventBus.refreshDataTable) {
            if(this.settings.eventBus.refreshDataTable != null && this.settings.eventBus.refreshDataTable.trim() != '' ) {
                EventBus.$off(this.settings.eventBus.refreshDataTable)
            }

            if(this.settings.eventBus.selectedItem != null && this.settings.eventBus.selectedItem != '' ) {
                EventBus.$off(this.settings.eventBus.selectedItem)
            }   

            if(this.settings.eventBus.removeSelectdItem != null && this.settings.eventBus.removeSelectdItem != '') {    
                EventBus.$off(this.settings.eventBus.removeSelectedItem)
            }
        } 
    }
}

</script>

<style scoped>
    .no_data {
        text-align:center !important;
    }

    #style-11::-webkit-scrollbar {
        width: 10px;
        background-color: #F5F5F5;
    }
    
    #style-11::-webkit-scrollbar-track {
        border-radius: 10px;
        background: rgba(0,0,0,0.1);
        border: 1px solid #ccc;
    }

    #style-11::-webkit-scrollbar-thumb {
        border-radius: 10px;
        background: linear-gradient(left, #fff, #e4e4e4);
        border: 1px solid #aaa;
    }

    #style-11::-webkit-scrollbar-thumb:hover {
        background: #fff;
    }

    #style-11::-webkit-scrollbar-thumb:active {
        background: linear-gradient(left, #22ADD4, #1E98BA);
    }

    .toolbar_btn_fab {
        margin-right:10px;
    }

    .dt_btn_edit {
        font-size:18px !important;
    }

    #dt_btn_delete {
        font-size:18px !important;
    }

    .no_data {
        color: #000 !important;
    }

    .v-card__text {
        color: rgba(0,0,0,0.90) !important;
    }

    .dialog_card_title {
        background-color: #F5F5F5 !important;
    }


</style>